var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question_mark_tooltip_icon",
    "data-name": "question mark tooltip icon",
    transform: "translate(-818.913 -1129.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_18",
    "data-name": "Path 18",
    transform: "translate(819.913 1129.913)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.000244140625 1.500003814697266 C 4.864594459533691 1.500003814697266 1.500003814697266 4.864594459533691 1.500003814697266 9.000244140625 C 1.500003814697266 13.13589477539062 4.864594459533691 16.50048446655273 9.000244140625 16.50048446655273 C 13.13589477539062 16.50048446655273 16.50048446655273 13.13589477539062 16.50048446655273 9.000244140625 C 16.50048446655273 4.864594459533691 13.13589477539062 1.500003814697266 9.000244140625 1.500003814697266 M 9.000244140625 3.814697265625e-06 C 13.97094345092773 3.814697265625e-06 18.00048446655273 4.029543876647949 18.00048446655273 9.000244140625 C 18.00048446655273 13.97094345092773 13.97094345092773 18.00048446655273 9.000244140625 18.00048446655273 C 4.029543876647949 18.00048446655273 3.814697265625e-06 13.97094345092773 3.814697265625e-06 9.000244140625 C 3.814697265625e-06 4.029543876647949 4.029543876647949 3.814697265625e-06 9.000244140625 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#6a6a6a"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(818.913 1130.913)",
    fill: "#6a6a6a",
    fontSize: 13,
    fontFamily: "Nunito-Bold, Nunito",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.016,
    y: 13
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkDark);
export default __webpack_public_path__ + "static/media/question-mark-dark.8a667d5d5a36410ddf84b569293d2b2b.svg";
export { ForwardRef as ReactComponent };